import Contract from "slotworks/utils/contract";
import Layers from "slotworks/graphics/layers/layers";
import { sequence, parallel } from "slotworks/utils/race-utils";
import * as TweenJS from "slotworks/utils/tween";
import currency from "slotworks/i18n/currency";
import { Signal } from "signals";
import { ShowGameElementsCommand } from "commands/respin-commands";
import { GlowTransitionCommand } from "commands/glow-transition-command";
import soundManager from "slotworks/sound/sound-manager";

export default class JackpotComponent {
    public static COUNT_TIME = 6700;
    public static WAIT_TIME = 4800;

    public static onAmountReached: Signal = new Signal();

    public static SCALE = 1.2;

    private complete: boolean;
    private valueText: PIXI.BitmapText;

    public start(amount: number, startAmount: number = 0, type: string = "mini"): Contract<void> {
        this.complete = false;
        return sequence([
            () => new Contract(resolve => {
                this.valueText = Layers.CelebrationForeground.getBitmapText("value");
                this.valueText.visible = true;
                this.valueText.text = currency.format(startAmount, undefined, undefined, true);
                Layers.Prompts.defaultScene().execute();
                resolve(null);
            }),
            () => this.startTween(startAmount, amount),
            () => Contract.wrap(() => {
                JackpotComponent.onAmountReached.dispatch();
                ShowGameElementsCommand();
            }),
            () => Contract.getTimeoutContract(JackpotComponent.WAIT_TIME),
            () => Contract.wrap(() => {
                soundManager.customEvent("jp_transition");
                GlowTransitionCommand().execute();
            }),
            () => sequence([
                () => Layers.CelebrationForeground.defaultScene(),
                () => Layers.CelebrationContent.defaultScene(),
                () => Layers.CelebrationBackground.defaultScene()
            ]),
            () => Contract.getTimeoutContract(700),
        ]);
    }

    public end() {
        JackpotComponent.onAmountReached.removeAll();
    }

    private init() {
        return new Contract(resolve => {
            this.valueText = Layers.CelebrationForeground.getBitmapText("value");
            
            resolve(null);
        });
    }

    private moveValueToJackpot() {
        return Contract.empty();
    }

    private startTween(from: number, amount: number) {
        return new Contract(resolve => {
            const obj = { value: from };
            this.valueText.visible = true;
            
            let tween = new TweenJS.Tween(obj)
                .to({ value: amount }, JackpotComponent.COUNT_TIME);

            tween.onComplete(() => { 
                this.complete = true;
                resolve(null);
            });
            tween.onUpdate(() => {
                this.valueText.text = currency.format(obj.value, undefined, undefined, true, true);
            }).start(); 
        });
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/jackpot/jackpot-component.ts